import React from 'react';
import GeckoFieldBase from '../_base.jsx';
import './index.scss';

class GeckoFieldNumber extends GeckoFieldBase {
  handleChange(event) {
    const { key, decimalPlaces } = this.field();
    let value = event.target.value;
    const handler = this.props.handler.bind(this);
    if (value === '') {
      return handler(key, null);
    }

    if (decimalPlaces !== undefined) {
      value = Number(value).toFixed(decimalPlaces);
    }

    return handler(key, Number(value));
  }

  handleBlur(event) {
    const { key, min, max } = this.field();
    if (this.props.field.onBlur) {
      this.props.field.onBlur(event);
    }
    const value = this.value();
    if (value === undefined || value === null) {
      return;
    }
    const handler = this.props.handler.bind(this);
    if (min !== undefined) {
      if (Number(min) > Number(value)) {
        return handler(key, min);
      }
    }
    if (max !== undefined) {
      if (Number(max) < Number(value)) {
        return handler(key, max);
      }
    }
    return;
  }

  render() {
    const { min, max, prefix, affix } = this.field();
    const hasPrefix = !!prefix;
    const hasAffix = !!affix;
    const value =
      this.value() === undefined || this.value() === null
        ? ''
        : String(this.value());
    return (
      <div
        id={this.renderId()}
        className={`gecko-field-type-number_container ${
          hasPrefix ? 'gecko-field-type-number_has-prefix' : ''
        } ${hasAffix ? 'gecko-field-type-number_has-affix' : ''}`}
      >
        {hasPrefix ? (
          <div className="gecko-field-type-number_prefix">{prefix}</div>
        ) : null}
        <input
          className="col-sm form-control gecko-ui-material"
          type="number"
          disabled={this.isDisabled()}
          value={value}
          onChange={this.handleChange.bind(this)}
          placeholder={this.config().placeholder || this.field().placeholder}
          onBlur={this.handleBlur.bind(this)}
          min={min}
          max={max}
        />
        {hasAffix ? (
          <div className="gecko-field-type-number_affix">{affix}</div>
        ) : null}
      </div>
    );
  }
}

export default GeckoFieldNumber;
